<template>
  <div>
      <div class="all">
        <div class="left">
          <div class="mb-10">已选中图片</div>
          <div v-for="(val,key) in chooselist" v-bind:key="key" style="position: relative">
            <img :src="val.url">
<!--            <span class="iconfont icon-close-circle-fill" @click="del(key)"></span>-->
          </div>
        </div>
        <div class="right">
          <div class="mb-10" @click="resort">可选图片列表
            <el-button type="primary" size="small" class="ml-10">重新排序</el-button>
          </div>
          <div v-for="(val,key) in imglist" v-bind:key="key" :class="val.is_choose ? 'bgimg choose' : 'bgimg'"
               :style="{backgroundImage:'url('+val.url+')'}" @click="choose(key)">
            <div class="pos">{{val.filename}}</div>
          </div>
        </div>
      </div>
      <el-button type="primary" size="medium" @click="submit" style="margin: 4px 430px 0">确认提交</el-button>
  </div>
</template>

<script>
export default {
  name: "multiple",
  components:{},
  model:{prop:'imglist' ,event:'change'},
  props : {
    isSort : { type : Boolean, default :  false}, //是否排序
    imglist : {type : [String,Array], default : ''},
    list : {type : [String,Array], default : ''},
  },
  data (){
    return{
      chooselist:[],
    }
  },
  methods:{
    resort:function (){
      let that = this;
      that.chooselist = [];
      // this.imglist = this.imglist.sort(function(a,b){//排序方法
      //   return a.filename - b.filename;
      // });
      this.imglist = this.imglist.sort(function(a,b){
        var x = a['filename'];
        var y = b['filename'];
        return ((x<y)?-1:(x>y)?1:0)
      });
      this.imglist.map(function (item) {
        item.is_choose = true;
        that.chooselist.push(item);
      })
    },
    choose:function (key){
      if(this.imglist[key].is_choose){
        // this.$_showToast('图片已选中');
        this.imglist[key].is_choose = false;
        let filename = this.imglist[key].filename;
        let a = this.chooselist.findIndex( function (v){
          return v.filename === filename
        })
        console.log(a);
        this.chooselist.splice(a,1);
      }else{
        this.imglist[key].is_choose = true;
        this.chooselist.push(this.imglist[key]);
      }
    },
    del:function (key){
      this.imglist[key].is_choose = false;
      this.chooselist.splice(key,1);
    },
    submit:function (){
      this.imglist = this.chooselist;
      this.$emit('submit', this.imglist);
      this.imglist = [];
      this.chooselist = [];
    },
  }
}
</script>

<style scoped>
.all{
  display: flex;
  height: 570px;
}
.left{
  width: 200px;
  height: 560px;
  overflow-y: auto;
  padding: 10px 10px 0;
  border: 1px solid #dcdfe6;
}
.left img{
  width: 100%;
  margin-bottom: 5px;
}
.right{
  width: 920px;
  height: 560px;
  overflow-y: auto;
  padding: 10px 10px 0;
  border: 1px solid #dcdfe6;
}
.bgimg{
  border-radius: 5px;
  border: 1px solid #ccc;
  display: inline-block;
  padding: 5px;
  margin: 0 10px 20px 0;
  width: 120px;height: 120px;
  background: #fff no-repeat center;
  background-size: contain;
  cursor: pointer;
}
.choose{
  border: 1px solid #dd524d;
  box-shadow: 0 0 2px 0 #dd524d;
}
.bgimg .pos{
  margin-top: 130px;
  width: 120px;
  text-align: center;
  font-size: 13px;
  overflow: hidden;
  white-space:nowrap;
}
.select{
  border: 2px solid #409eff;
}
.icon-close-circle-fill{
  color: #dd524d;
  position: absolute;
  right: -2px;
  top:-6px;
  font-size: 20px;
  cursor: pointer;
}
</style>